export function shouldScrollToFlowsSection(hash: string, isLoading: boolean): boolean {
  return hash === "#flows" && !isLoading
}
